import {types} from "mobx-state-tree";


export const UserModel = types.model('UserModel',{
  uuid: types.maybe(types.string),
  email: types.maybe(types.string),
})
